declare var $: any;

export class TemplateTransformer {

    static parseFields(html: string): any {
        let dom = $.parseHTML(html);
        let fields = {};

        $(dom).find('span.ql-placeholder-content')
            .map((_, val) => ({id: val.getAttribute('data-id'), label: val.getAttribute('data-label')}))
            .each((_, res) => fields[res.id] = {label: res.label});

        $(dom).find('a.ql-url')
            .each((_, el) => {
                let key = $(el).attr('data-id');
                if (key) fields[key] = true;
            });

        $(dom).find('img.ql-image')
            .each((_, el) => {
                let key = $(el).attr('data-id');
                if (key) fields[key] = true;
            });

        return fields;
    }

    static toPreviewTemplate(html: string, placeholders: { [key: string]: string }): string {
        let dom = $.parseHTML(html);
        $(dom).find('span.ql-placeholder-content')
            .each((_, el) => {
                let id = $(el).attr('data-id');
                $(el).text(placeholders[id]);
            });

        $(dom).find('a.ql-url')
            .each((_, el) => {
                let previewUrl = $(el).attr('data-label');
                $(el).attr('href', previewUrl);
            });

        $(dom).find('img.ql-image')
            .each((_, el) => {
                let previewUrl = $(el).attr('data-label');
                $(el).attr('src', previewUrl);
            });

        return $('<div>').append(dom).html();
    }

    static toRawTemplate(html: string, config: any): string {
        let dom = $.parseHTML(html);
        $(dom).find('span.ql-placeholder-content')
            .each((_, el) => {
                let id = $(el).attr('data-id');
                $(el).text(`{{ ${id} }}`)
            });

        $(dom).find('a.ql-url')
            .each((_, el) => {
                let id = $(el).attr('data-id');
                if (id) $(el).attr('href', `{{ ${id} }}`);
            });

        $(dom).find('img.ql-image')
            .each((_, el) => {
                let id = $(el).attr('data-id');
                if (id) $(el).attr('src', `{{ ${id} }}`);
            });
            
        return $('<div>').append(dom).html();
    }

    static toUserTemplate(html: string, config: any): string {
        let dom = $.parseHTML(html);
        $(dom).find('span.ql-placeholder-content')
            .each((_, el) => $(el).text($(el).attr('data-label')));
            // .html();
        // debugger
        return $(dom).html();
    }

    static updatePlaceholders(html: string, placeholdersToUpdate: any) {
        let dom = $.parseHTML(html);

        $(dom).find('span.ql-placeholder-content')
            .each((_, el) => {
                let id = $(el).attr('data-id');
                let newData = placeholdersToUpdate[id];
                if (newData) {
                    $(el).text(newData.displayValue)
                        .attr('data-label', newData.displayValue)
                        .attr('data-id', newData.key);
                }
            });

        return $(dom).html();
    }
}



// WEBPACK FOOTER //
// ./src/app/common/template/util/template-transformer.ts